var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrolling-page"},[_vm._t("default",null,null,{ isPageFocused: _vm.isPageFocused, isElementFocused: _vm.isElementFocused })],2)}
var staticRenderFns = []

export { render, staticRenderFns }